"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Script = void 0;
var _script = _interopRequireDefault(require("next/script"));
var _jsxRuntime = require("react/jsx-runtime");
const Script = ({
  id,
  src
}) => /*#__PURE__*/(0, _jsxRuntime.jsx)(_script.default, {
  crossOrigin: "anonymous",
  id: id,
  src: src,
  strategy: "afterInteractive"
});
exports.Script = Script;
